import { RoleCapacity } from '@ng-gems/api';
import { CapacityViewModel } from '@ng-gems/api/midback';

import { AccessControlCapacity } from '@models/account/access-control-capacity.model';

import { ApiAdapter } from './adapter';

export class AccessControlCapacityAdapter extends ApiAdapter<AccessControlCapacity> {
  get(json: CapacityViewModel): AccessControlCapacity {
    return new AccessControlCapacity({ name: json.fullName as RoleCapacity, description: json.description });
  }
}
